import { render, staticRenderFns } from "./ChromaKeyBackground.vue?vue&type=template&id=19693fa6&scoped=true"
import script from "./ChromaKeyBackground.vue?vue&type=script&lang=js"
export * from "./ChromaKeyBackground.vue?vue&type=script&lang=js"
import style0 from "./ChromaKeyBackground.vue?vue&type=style&index=0&id=19693fa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19693fa6",
  null
  
)

export default component.exports